import range from 'lodash/range';
import {eventInEditMode} from '~/CreateFabricGreetingCard/reducers/details/selectors';
import {
  selectCustomSharableLink,
  selectShortLink,
} from '~/CreateFabricGreetingCard/reducers/eviteEvent/selectors';
import {selectIsPremium} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';
import {addGuestsPreCondition} from '~/common/fabric/EventGuests/components/DisplayCondition/addGuestsCondition';

export const selectGuests = ({guests}) => guests;

export const selectGuestsPage = ({guests}) => guests?.guests;

export const selectTotalDrafts = (state) => state?.guests?.totalDrafts;
export const selectTotalSent = (state) => state?.guests?.totalSent;
export const selectGuestCount = (state) => state.guests?.guests?.count;

export const selectIsFetchingGuests = ({guests}) => guests.fetching;

export const selectIsAddingGuest = ({guests: {addingGuest}}) => addingGuest;

export const selectGuestsUiEmail = (state) => state.guests.ui.email;
export const selectGuestsUiName = (state) => state.guests.ui.name;
export const selectGuestsUiPhone = (state) => state.guests.ui.phone;

export const selectIsGuestsFabricGreetingCard = ({guests}) => guests?.fabricGreetingCard;

export const selectEviteAddressBook = ({guests: {contacts}}) => contacts;
export const selectGoogleAddressBook = ({guests: {imports}}) => imports;

export const selectEventGuestListParams = ({guests: {eventGuestListParams}}) =>
  eventGuestListParams;
export const selectContactsParams = ({guests: {contactsParams}}) => contactsParams;

export const selectLetters = ({guests: {letters}}) => letters;

export const selectEvents = ({guests: {events}}) => events;

export const selectEventsListScroll = ({
  guests: {
    ui: {eventsListScroll},
  },
}) => eventsListScroll;

export const selectEventGuestList = ({guests: {eventGuestList}}) => eventGuestList;

export const selectEventsParams = ({guests: {eventsParams}}) => eventsParams;
export const selectSelectedPastEvent = ({guests: {selectedPastEvent}}) => selectedPastEvent;
export const selectGuestListParams = ({guests: {guestListParams}}) => guestListParams;
export const selectGuestsToBeAdded = ({guests: {guestsToBeAdded}}) => guestsToBeAdded;
export const selectPagination = (guests) => {
  const {current_page: curr, num_pages: total} = guests;

  const window = 5;
  const tolerance = 3;

  const low = parseInt(curr, 10) - tolerance;
  const high = low + window;

  const min = Math.max(Math.min(low, total - window), 0);
  const max = Math.min(Math.max(high, window), total);
  const pages = range(min, max);

  return {
    window,
    tolerance,
    low,
    high,
    min,
    max,
    pages,
    curr: parseInt(curr, 10),
    total,
  };
};

export const selectContactsPagination = (state) => selectPagination(state.guests.contacts);
export const selectEventsPagination = (state) => selectPagination(state.guests.events);
export const selectInvitationMakerFlow = (state) => selectGuests(state).invitationMakerFlow;

export const selectEventGuestListPagination = (state) =>
  selectPagination(state.guests.eventGuestList);

export const selectGuestPagination = ({guests}) => {
  const {current_page: curr, num_pages: total} = guests.guests;

  const window = 5;
  const tolerance = 3;

  const low = parseInt(curr, 10) - tolerance;
  const high = low + window;

  const min = Math.max(Math.min(low, total - window), 0);
  const max = Math.min(Math.max(high, window), total);
  const pages = range(min, max);

  return {
    window,
    tolerance,
    low,
    high,
    min,
    max,
    pages,
    curr: parseInt(curr, 10),
    total,
  };
};

export const selectImportsPagination = (state) => selectPagination(state.guests.imports);

export const selectShowShareableLinkBanner = (state) => {
  const isPremium = selectIsPremium(state);
  const inEditMode = eventInEditMode(state);
  const invitationMakerFlow = selectInvitationMakerFlow(state);
  return (
    !isPremium && // show on free invitations only
    !inEditMode && // show in create flow only (not edit flow)
    !invitationMakerFlow && // should not show for invitation maker flow
    state.guests.showShareableLinkBanner
  ); // show only if user hasn't dismissed it
};

export const selectShowShareableLink = (state) => {
  const inEditMode = eventInEditMode(state);
  const addGuestsPostCreateConditionsMet = addGuestsPreCondition(state);
  return addGuestsPostCreateConditionsMet && inEditMode;
};

export const selectGuestById =
  (guestId) =>
  ({guests}) => {
    const {page} = guests.guests;
    return page.find((guest) => guest.guest_id === guestId);
  };

export const selectIsLoadingAddressBook = ({guests}) => guests.ui.loadingAddressBook;
export const selectShowSearchGuests = ({guests}) => guests.ui.searchGuests;

export const selectShareableShortLink = (state) => selectShortLink(state);

export const selectCustomLink = (state) => selectCustomSharableLink(state);

export const selectGuestListSearchParam = ({guests}) => guests.guestListParams.q;
export const selectEventId = (state) =>
  window.evite_event?.id || state.eventDetails?.eventId || state.eviteEvent?.id || state.ecard?.id;

export const selectEventOptions = (state) => {
  return state.giftingOptions?.options ?? state.eviteEvent?.options;
};
